import { Component, OnInit, Inject } from '@angular/core';
import { SoundEnum } from 'src/app/enums/sound.enum';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { TranslateService } from '@ngstack/translate';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { CalendarService } from 'src/app/services/http/business/calendar/calendar.service';
import { IError } from 'src/app/interfaces/error.interface';

@Component({
  selector: 'app-log-calendar-event',
  templateUrl: './log-calendar-event.component.html',
  styleUrls: ['./log-calendar-event.component.css']
})
export class LogCalendarEventComponent implements OnInit {
  form: FormGroup;
  errors = new Array();
  holidayList: any;
  errObject: any;
  holidayTypeId: any=0;
  param: any;
  errorList: IError[] = [];
  constructor(
    private fb: FormBuilder,
    private snackBar: SnackBarService,
    private errorService: ErrorsService,
    public translate: TranslateService,
    private calendarService: CalendarService,
    private dialogRef: MatDialogRef<LogCalendarEventComponent>,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {

    this.createForm();
    this.getHolidayTypeList();
  }
  createForm() {
    this.form = this.fb.group({

      HolidayTypeId: [
        this.data["isUpdate"] ? this.data["HolidayTypeId"].toString() : null,
        Validators.compose([
          Validators.required
        ])
      ],
      Explain: [
        this.data["isUpdate"] ? this.data["Explain"].toString() : null,
        Validators.compose([
          this.data["isUpdate"] ? null : Validators.required
        ])
      ],

    })
  }

  getHolidayTypeList() {
    this.calendarService.calendarHolidayList().subscribe(res => {
      this.holidayList = res.DataList;
    });
  }

  submit(form: any) {

    this.errors = new Array();

    let command = {
      CompanyEncryptId: this.data.companyId,
      CalendarHolidayList: [
        {
          HolidayTypeId: form.HolidayTypeId,
          Explain: form.Explain,
          HolidayTypeName: null
        }
      ],
      DailyDate: this.data.dailyDate,
      DatePersian: null,
      DateArabic: null
    }
    this.calendarService.save(command).subscribe(
      () => {
        this.snackBar.OpenSnackBar(
          this.translate.get("success.registration"),
          "ok",
          5000,
          SoundEnum.beep
        );
        this.dialogRef.close();
      },
      error => {
        // this.errObject = this.errorService.getError(error);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(error);
        this.errorList = this.errorService.getErrorList(error.error);
      }
    );

  }

  onNoClick() {
    this.dialogRef.close();
  }
}
